<template lang="pug">	
	tr.campaign-budget-product.colored-editors.align-right-editors(@click="dataType === 'total' && $Data.toggleSelectedIdInArray(product.Oid, expandedItems)", :class="[dataType === 'total' ? 'total-row' : 'details']")
		template(v-if="dataType == 'total'")
			td
				.product.horizontal-spacing.clickable
					.expander(:class="{ expanded: expandedItems.indexOf(product.Oid) > -1 }")
						i.fas.fa-chevron-right
					.icon
						i(:class="[product.type.icon]")
					.name.nowrap {{product.Name}}
			template(v-for="item in localBudgetItems")
				td.budget-td(v-if="dataType == 'total'")
					.budget-total.flex-row.justify.clickable
						.left
						.flex-row
							template(v-if="$scopedSlots['total']")
								.value
									slot(name="total")
							.value(v-else) {{$Data.formatNumber(item.product.TotalSum)}}
							.description(v-if="false && item.product.recurrent != false") {{getReccurencyPeriod(item.budget)}}
		template(v-if="dataType == 'budget'")
			td {{$tCaption('Budget')}}
			template(v-for="item in localBudgetItems")
				td.budget-td.align-right-editors
					DxNumberBox(:value.sync="item.product.TotalSum", :format="getCurrencyFormat(item.budget)", @value-changed="onBudgetItemChange(item)", :disabled="info.readonly")
		template(v-if="dataType == 'display'")
			td {{$tCaption('Display component')}}
			template(v-for="item in localBudgetItems")
				td.budget-td.colored-editors
					.flex-row.full-width.space
						.flex-row.flex-1.justify
							.left.flex-1
							.flex-row
								span {{$tCaption('CPM')}}
								DxNumberBox.number-edit.flex-1(:value.sync="item.product.RatePrice", :format="currencyFormat", :width="40", @value-changed="onBudgetItemChange(item)", :disabled="info.readonly")
						.flex-col
							.flex-row
								.data-value {{$Data.formatNumber(item.product.Quantity, 'fixedPoint')}}
								.data-description {{$tCaption('impressions')}}
							.flex-row
								.data-value {{$Data.formatNumber(item.product.Sum)}}
								.data-description {{$tCaption('dollars')}}
		template(v-if="dataType == 'geofencing'")
			td {{$tCaption('Geofencing component')}}
			template(v-for="budget in localBudgetItems")
				td.budget-td
					.flex-row.space
						dxCheckBox(:value.sync="budget.product.GeoFencingEnabled", :width="35", @value-changed="onBudgetItemChange(budget)", :disabled="info.readonly")
						template(v-if="budget.product.GeoFencingEnabled")
							.flex-row.flex-1.justify-end
								span {{$tCaption('CPM')}}
								DxNumberBox.bool.number-edit(:value.sync="budget.product.GeoFencingPrice", :format="currencyFormat", @value-changed="onBudgetItemChange(budget)", :width="40", :disabled="info.readonly")
							.flex-col
								.flex-row
									span {{$tCaption('Impressions')}}
									DxNumberBox.bool.number-edit(:value.sync="budget.product.GeoFencingQuantity", format="fixedPoint", @value-changed="onBudgetItemChange(budget)", :width="80", :disabled="info.readonly")
								.flex-row.justify-end
									.data-value {{$Data.formatNumber(budget.product.GeoFencingSum)}}
									.data-description {{$tCaption('dollars')}}
		template(v-if="dataType == 'remarketing'")
			td {{$tCaption('Remarketing')}}
			template(v-for="budget in localBudgetItems")
				td.budget-td
					.flex-row(v-if="budget.product.GeoFencingEnabled")
						dxCheckBox(:value.sync="budget.product.RemarketingEnabled", :width="35", @value-changed="onBudgetItemChange(budget)", :disabled="info.readonly")
						.flex-row(v-if="budget.product.RemarketingEnabled")
							.data-value
								DxNumberBox.bool.number-edit(:value.sync="budget.product.RemarketingPrice", :format="currencyFormat", @value-changed="onBudgetItemChange(budget)", :disabled="info.readonly")
							.data-description {{$tCaption('Remarketing Upcharge')}}
		template(v-if="dataType == 'custom'")
			td {{customName}}
			template(v-for="budget in localBudgetItems")
				td.budget-td
					.data-value.flex-row.full-width
						slot(name="custom", :budget="budget", :valueChanged="() => onBudgetItemChange(budget)")
</template>

<script>
	import _ from 'lodash';
	import { DxNumberBox } from 'devextreme-vue/number-box';
	import DxButton from 'devextreme-vue/button';
	import DxCheckBox from 'devextreme-vue/check-box';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxSelectBox from 'devextreme-vue/select-box';
	import Loader from 'app-core/Loader.vue';
	import EditableLabel from 'app-core/EditableLabel.vue';

	export default {
		translationCategory: 'campaign.Budget',
		name: 'campaign-budget',
		components: {
			DxButton,
			DxNumberBox,
			DxCheckBox,
			DxTextBox,
			DxSelectBox,
			Loader,
			EditableLabel
		},
		props: ['info', 'campaignBudgets', 'product', 'expandedItems', 'budgetItems', 'dataType', 'customName', 'calcBudgetResolver'],
		data() {
			return {
				localBudgetItems: this.budgetItems,
				isUpdatingItems: false,
				currencyFormat: '$#0.##',
			};
		},
		computed: {
			campaign() {
				return this.info?.campaign;
			}
		},
		watch: {
			budgetItems: {
				handler(v) {
					this.isUpdatingItems = true;
					this.localBudgetItems = v;
					setImmediate(() => this.isUpdatingItems = false);
				},
				deep: true
			}
		},
		mounted() {
			if (__DEBUG__)
				window.budgetProduct = this;
			this.$createUpdateCampaignBudgetProduct = _.debounce((budgetItem, callback) => this.createUpdateCampaignBudgetProduct(budgetItem).finally(callback), 1000, {
				'leading': false,
				'trailing': true
			});
		},
		destroyed() {
			delete this.$createUpdateCampaignBudgetProduct;
		},
		methods: {
			getCurrencyFormat(budget) {
				return `${this.currencyFormat} ${this.getReccurencyPeriod(budget)}`;
			},
			getReccurencyPeriod(budget) {
				if (budget) {
					switch(budget.BudgetPeriod) {
						case 0:
							return this.$tCaption('weekly');
						case 1:
							return this.$tCaption('monthly');
					}
				}
				return '';
			},
			onBudgetItemChange(budgetItem) {
				if (this.isUpdatingItems) return;
				if (this.calcBudgetResolver)
					this.calcBudgetResolver(budgetItem.budget, budgetItem.product);
				this.createUpdateCampaignBudgetProduct(budgetItem);
			},
			createUpdateCampaignBudgetProduct(budgetItem) {
				if (!budgetItem.store) {
					if (budgetItem.Oid) {
						budgetItem.store = Promise.resolve(true);
					} else {
						budgetItem.store = this.$Data.postExternalApi('CampaignBudgetProduct/CreateUpdateBudgetProduct', budgetItem.product).then(r => {
							if (!budgetItem?.product?.Oid && r?.Data?.Oid) {
								budgetItem.product.Oid = r?.Data?.Oid;
							}
						});
						return budgetItem.store;
					}
				}
				return budgetItem.store.then(() => 
					this.$Data.postExternalApi('CampaignBudgetProduct/CreateUpdateBudgetProduct', budgetItem.product).then(r => {
						if (!budgetItem?.product?.Oid && r?.Data?.Oid) {
							budgetItem.product.Oid = r?.Data?.Oid;
						}
					})
				);
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.campaign-budget-product {
		.product {
			.icon {
				width: 18px;
				padding-left: 2px;
			}
		}

		.budget-total {
			font-weight: 100;
		}
	}
</style>
